module.exports = __webpack_public_path__ + "img/zhongtong-background.1821e706.png";